const messages = {
  title: "Produktbroschüren & Preislisten",
  description:
    "Laden Sie hier aktuellen Broschüren, Flyer und Preislisten zu unseren Bridgestone und Firestone Reifen für Pkw, SUV und Transporter herunter.",
  brochureCategories: {
    products: "Produkte",
    brand_and_solutions: "Marke & Lösungen",
    season_and_promotions: "Saison & Aktionen",
    format: "Format",
    cars_and_vans: "Pkw & Transporter",
    summer: "Sommer",
    winter: "Winter",
    promotions: "Aktionen",
    all_season: "Ganzjahresreifen",
    truck_and_buses: "Lkw & Bus",
    motorcycle: "Motorrad",
    agriculture: "Landwirtschaft",
    construction_machinery: "Baumaschinen",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialien",
    brochures: "Produktbroschüren",
    price_list: "Preislisten",
    materials: "Materialien",
    video_in_store: "Video mit Untertitel",
    video_online: "Video ohne Untertitel",
    banner_website: "Banner",
    banner_social_media: "Soziale Medien",
    logos: "Logos",
  },
  searchMedia: "Suchbegriff eingeben",
  searchResults: "Suchergebnisse",
};

export default {
  messages,
};
